import { FeatureFlagProvider } from '@sennder/shell-utilities'

export const featureFlag = new FeatureFlagProvider()
